import {generateSchema} from "./form-schema";

/**
 * Get form schema for given vehicle type.
 * If no schema for that type is available, undefined is returned.
 * @return {Promise<unknown>}
 */
export function getSchemaForType(messages, coverageTypes, vehicleType) {
  return new Promise((resolve, reject) => {
    if (!coverageTypes || coverageTypes.length <= 0) {
      reject("No schema available for vehicle type " + vehicleType);
    } else {
      resolve(enhanceLabels(messages, generateSchema(coverageTypes)));
    }
  });
}

export function parseSchema(messages, schema) {
  return enhanceLabels(messages, schema);
}

function enhanceLabels(messages, schemaToEnhance) {
  if (schemaToEnhance.groups) {
    schemaToEnhance.groups.forEach(group => {
      group.legend = messages[group.legend];
      enhanceLabelOnFields(messages, group.fields);
    });
  }

  enhanceLabelOnFields(messages, schemaToEnhance.fields);

  return schemaToEnhance;
}

function enhanceLabelOnFields(messages, fields) {
  if (!fields) {
    return;
  }

  fields.forEach(field => {
    field.help = setSafeLanguageLabel(messages, field.help);
    field.xorErrorMessage = messages[field.xorErrorMessage] || field.xorErrorMessage;
  });
}

/**
 * Returns language label value if found and not equal to key (aka not set).
 */
function setSafeLanguageLabel(messages, key) {
  return (messages[key] && messages[key] !== key) ? messages[key] : undefined;
}
